const selectLoyaltyNewDomain = () => (state) => state.loyaltyNew;

export { selectLoyaltyNewDomain };
